import DateTime from '../date-time'

export default class PACPerformance {
  startTime: DateTime
  label?: string

  constructor(values: any) {
    this.startTime = values.startTime
    this.label = values.label
  }

  getEndDateString(): string {
    const endDate = new Date(this.startTime.iso)
    const month = PACPerformance.zeroPadded(endDate.getMonth() + 1)
    const date = PACPerformance.zeroPadded(endDate.getDate())

    const endDateString = `${endDate.getFullYear()}-${month}-${date}`
    return endDateString
  }

  private static zeroPadded(number: number): string {
    return number > 9 ? number.toString() : `0${number}`
  }
}
